import {WithStyledProps} from '@coolcolduk/ui-mui';
import {SvgIconComponent} from '@mui/icons-material';
import {Card, CardActions, CardContent, CardHeader, Typography, styled} from '@mui/material';
import {FeatureStatus} from '../../types/FeatureStatus';
import {isProd} from '../../util/env/getEnv';

const getStatusColor = (featureStatus: FeatureStatus) => {
  switch (featureStatus) {
    case FeatureStatus.PROD:
    case FeatureStatus.ADMIN:
      return 'success.main';
    case FeatureStatus.ALPHA:
    case FeatureStatus.RETIRED:
      return 'info.main';
    case FeatureStatus.BETA:
      return 'warning.main';
    default:
      return 'error.main';
  }
};

const getStatusLabel = (featureStatus: FeatureStatus) => {
  switch (featureStatus) {
    case FeatureStatus.PROD:
      return 'Production';
    case FeatureStatus.ADMIN:
      return 'Admin';
    case FeatureStatus.ALPHA:
      return 'Alpha';
    case FeatureStatus.RETIRED:
      return 'Retired';
    case FeatureStatus.BETA:
      return 'Beta';
    default:
      return 'Unknown';
  }
};

export interface FeatureDashboardCardProps {
  title: string;
  description: string;
  icon: SvgIconComponent;
  status: FeatureStatus;
  onClick: () => void;
}

function FeatureDashboardCard({
  title,
  description,
  icon: Icon,
  status,
  onClick,
  className,
}: WithStyledProps<FeatureDashboardCardProps>) {
  return (
    <Card
      className={className}
      onClick={onClick}
      sx={{cursor: 'pointer', display: 'flex', flexDirection: 'column', p: 1}}
    >
      <CardHeader title={<Typography variant="h6">{title}</Typography>} avatar={<Icon fontSize="large" />} />

      <CardContent>
        <Typography variant="body2" color="textSecondary" mb={2}>
          {description}
        </Typography>
      </CardContent>

      {(!isProd() || status !== FeatureStatus.PROD) && (
        <CardActions sx={{mt: 'auto', justifyContent: 'center'}}>
          <Typography
            variant="body2"
            color="white"
            sx={{width: '50%', textAlign: 'center', backgroundColor: getStatusColor(status), borderRadius: 1}}
          >
            {getStatusLabel(status)}
          </Typography>
        </CardActions>
      )}
    </Card>
  );
}

export default styled(FeatureDashboardCard, {name: 'CcFeatureDashboardCard'})<FeatureDashboardCardProps>();
